import React from "react";
import SvGraphics from "../../../../assets/SvGraphics";
import {renderToString} from "react-dom/server";
import {authenticationService} from "../../../../services/AuthenticationService";

export class CannabisPDFAccepted {


    params

    constructor(params) {
        this.params = params
    }

    getInstructions() {
        let instruction = (
            '<div dir="rtl" class="pdfFile-details-block">' +
            '<div dir="rtl" class="pdfFile-details-title-block">' +
            '<div dir="rtl" class="pdfFile-details-title-label">הנחיות לשימוש בקנביס</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item-full">' +
            '<div dir="rtl" class="pdfFile-details-item-label">הוסבר למטופל/ת בפירוט על הנושאים הבאים:</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-Block">' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-point"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">הסכנות הפוטנציאליות משימוש בקנביס רפואי כוללות:</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">אין מידע מספק לגבי תופעות לואי לטווח ארוך של שימוש בקנביס ועל פגיעה קוגניטיבית ופגיעה בזיכרון ובהליכי חשיבה.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">בשימוש לטווח ארוך נמצאו חדרי מוח מורחבים ביחס לגיל דבר המעיד על אטרופיה מוחית עם פגיעה בחומר הלבן והאפור.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">הקנביס יכול לגרום להפרעות נפשיות חמורות מסוג דיכאון עמוק התנהגות מאנית, סכיזופרניה, פסיכוזה, מחלת רדיפה, ועוד.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">הגברת סיכון לאירועים טרומבואמבוליים ולאירועים מוחיים עם פגיעה נוירולוגית קשה עד מוות.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">הגברת סיכון לגידולים סרטנים שונים.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">קיימת ירידה בגובה ובמשקל בצריכה בגיל צעיר.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">אין אישור לכך כי הקנביס הינה תרופה מקובלת. אין אנו יודעים מה משמעות השימוש לטווח ארוך.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">הטיפול פוגע בפריון, עקב פגיעה בקליטת העובר בנשים, ופגיעה באיכות הזרע בגברים.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence2">צריכה בעת הריון והנקה – קיימת ירידה בגובה ובמשקל בתינוק, וירידה בכמות החומר האפור במוח דבר העלול לגרור פיגור שכלי. לכן נשים בגיל פריון , יש להפסיק קנביס במידה ונכנסות להריון ולדווח לרופא המטפל ולגניקולוג העוקב אחר ההיריון.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">יש סכנה להתמכרות גופנית ו/או נפשית וכי הגמילה אינה קלה בחלק מהמקרים, ומלווה בסבל גופני ונפשי.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-point"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">הצהרת מטופל לגבי המידע הרפואי הרלוונטי שלו:</div>' +
            '</div>' +

            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">אני מאשר כי הזדהיתי על ידי תצלום תעודת זהות שלי, שיתועדו במערכת המרכז הארצי לרפואת כאב.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">אני מאשר כי העברתי את כל המידע הרלוונטי למערכת המרכז הארצי לרפואת כאב ושם תועדה במערכת הממוחשבת.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence3">אני יודע כי ההמלצה לטיפול בקנאביס רפואי תינתן בהתאם לנוהל 106 של משרד הבריאות, בהתאם  למצבי ולהיסטוריה רפואית שלי  בהתאם  לטיפולים  שאקבל ובהתייחסות לתופעות הלוואי האפשריות ולהתוויות הנגד ,ולהשפעות גומלין בין התרופות שאני נוטל/ת ובין הטיפול בקנביס, זאת לאחר שהתייעצתי וקיבלתי אישור מהרופא המטפל הממליץ על השימוש בקנביס.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence2">אני מתחייב להמשיך במעקב רפואי מסודר על ידי הרופא המטפל שלי ולעדכן את צוות המרכז הארצי לרפואת כאב על ידי מכתב מרופא זה בכל חידוש רישיון.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence2">אני מתחייב להודיע להמרכז הארצי לרפואת כאב במידה ואני מחזיק (או אחזיק בעתיד), רישיון נהיגה מקצועי (נהג הסעות, מוניות, אוטובוסים, משאיות, רישיון טיס, נהג קטר ועוד)</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">אני מתחייב להודיע במידה ויש לי (או אקבל בעתיד) רישיון לנשיאת נשק.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence2">אני נותן את הסכמתי לכך כי המרכז הארצי לרפואת כאב יכולה לדווח למרב"ד ולמשרד הפנים על השימוש בקנביס לבעלי רישיונות נהיגה, החזקת נשק או הפעלה של כלים כבדים.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence2">אני נותן את הסכמתי  שכל גורם רפואי שיידרש על ידי משרד הבריאות, יעביר למנהל לפי פקודת הסמים המסוכנים ולפועלים מטעמו ובכלל זה צוות היחידה לקנביס רפואי במשרד הבריאות( היק"ר ) כל מידע רלוונטי לבקשה אודותי המצוי ברשותם.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">אני נותן את הסכמתי למחלקה למידע והערכה במשרד הבריאות למסור כאמור מידע על אשפוזים פסיכיאטרים שעברתי ככל שהיו.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">אני מבין כי המרכז הארצי לרפואת כאב אינה אחראית על טיב ואספקת הקנביס אלא משרד הבריאות.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">אני מבין כי הרופא המטפל יכול בכל שלב להפסיק את הרישיון על פי שיקול דעתו בלבד.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence2">אני מבין ומסכים כי המרכז הארצי לרפואת כאב לא יחדשו רישיון במידה והרופא המטפל לא ימליץ על המשך הטיפול. במקרה כזה יהיה באחריות החולה למצוא רופא שיחדש את רישיונו.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence2">אני מבין כי כל הפרה של תנאי הרישיון כמו חוסר עמידה במעקבים ובהבאת האישורים הרלוונטיים ועוד, הם סיבה להפסקת חידושי הרישיונות.</div>' +
            '</div>' +

            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-point"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">הנחיות נוספות:</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence3">מומלץ לבחור בצורת צריכה שאינה עישון (אידוי, שמן וכו\'), עקב סכנה לנזקים ריאתיים משמעותיים מהעישון והחשיפה לחומרים בקנביס. הסיכון עולה לדלקות גרון, דלקות סמפונות, דלקות וזיהומי מערכת הנשימה העליונה, התפתחות כרונית של אסטמה ואמפיזמה (גנחת ונפחת) וסרטן ריאות.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">במידה ויש תופעות לוואי קלות, ניתן לרדת במינון ולהמשיך במינון נמוך יותר.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">במידה ותופעות לוואי חזקות יותר להפסיק נטילה ולפנות לרופא משפחה או מיון .</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">ניתן לפנות אל המרכז הארצי לרפואת כאב כדי לדווח ולשנות טיפול או מינון בהתאם בהמלצת רופא מטפל.</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">במידה והנך מרגיש כי יש לך בעיה של התמכרות לקנביס אליך לדווח מיידית לרופא המטפל שלך ולעדכן את המרכז הארצי לרפואת כאב.</div>' +
            '</div>' +

            '<div dir="rtl" class="pdfFile-Instruction-sentence">כל הכתוב מעל נכתב בשפת זכר לצורך נוחות אך מתייחס לשני המינים.</div>' +


            '</div>' +
            '</div>' +
            '</div>'
        )

        return instruction
    }


    getPatientAge() {
        if (this.params.Date_of_birth !== null) {
            let todayDate = new Date().toISOString()
            let todayExactDate = (todayDate.split('T'))[0].split('-')
            let currentYear = todayExactDate[0]
            let currentMonth = todayExactDate[1]
            let birthDate = this.params.Date_of_birth ? this.params.Date_of_birth.toISOString() : ""
            let exactDate = (birthDate.split('T'))[0].split('-')
            let yearDiff = currentYear - exactDate[0]
            let monthDiff = currentMonth - exactDate[1]
            if (monthDiff < 0) {
                return (yearDiff - 1) + "." + (12 + monthDiff)
            } else {
                return yearDiff + "." + (monthDiff)
            }
        }
        return ""
    }

    initHTML() {
        let emailSVG = renderToString(<SvGraphics style={{marginTop: '6px', marginRight: '10px', marginLeft: '5px'}}
                                                  svgname={"email-iconBlack"} width={'9px'} min-height={'14px'}/>)
        let logo = renderToString(<SvGraphics style={{marginTop: '6px', marginRight: '25px', marginLeft: '5px'}}
                                              svgname={"painClinicLogo"} width={'150px'} min-height={'14px'}/>)

        let phoneSVG = renderToString(<SvGraphics style={{marginRight: '15px', marginLeft: '5px'}}
                                                  svgname={'phone-iconBlack'} width={'9px'} min-height={'14px'}/>)
        let checkSVG = renderToString(<SvGraphics svgname={'check-iconBlack'} width={'11px'} min-height={'14px'}
                                                  style={{marginTop: '10px', marginLeft: '10px'}}/>)
        let firstName = this.params.First_name ? this.params.First_name : ""
        let lastName = this.params.Last_name ? this.params.Last_name : ""
        let id = this.params.ID_passport ? this.params.ID_passport : ""
        let age = this.getPatientAge()
        let phone = this.params.Phone_num1 ? this.params.Phone_num1 : ""
        let mail = this.params.Email ? this.params.Email : ""

        let programm = this.params.choose_programm ? this.params.choose_programm : ""
        programm = programm === "new" ? "הוצאת רישיון חדש" : programm
        programm = programm === "renew" ? "חידוש רישיון למטופלים קיימים" : programm
        programm = programm === "renew2" ? "חידוש רישיון למטופלים חדשים" : programm
        programm = programm === "change" ? "חידוש רישיון מעל שנה (ביקור II)" : programm
        programm = programm === "newPrescription" ? "הוצאת מרשם חדש"  : programm
        programm = programm === "renewPrescription" ? "חידוש מרשם למטופלים קיימים" : programm
        programm = programm === "renew2Prescription" ? "חידוש מרשם למטופלים חדשים" : programm

        let treatmentsArr = []
        let treatmentInstructionMethod = ""
        let includeFlower = false
        let includeOil = false
        let addFlowerInstruction = false
        let patientTreats = this.params.patientTreatments ? this.params.patientTreatments : []
        for (let i = 0; i < patientTreats.length; i++) {
            let patientTreat = patientTreats[i]
            let tratmentCat = patientTreat && patientTreat.TreatmentCategory ? patientTreat.TreatmentCategory : ""
            let tratmenDosage = patientTreat && patientTreat.TreatmentMonthlyDosage ? patientTreat.TreatmentMonthlyDosage : ""
            let tratmenTakeMethod = patientTreat && patientTreat.TreatmentIntakeMethod ? patientTreat.TreatmentIntakeMethod : ""
            let Other_treatment_intake_method = patientTreat && patientTreat.Other_treatment_intake_method ? patientTreat.Other_treatment_intake_method : ""

            includeFlower = includeFlower ? includeFlower : tratmenTakeMethod === "Flower"
            includeOil = includeOil ? includeOil : tratmenTakeMethod === "Oil drops"

            tratmenTakeMethod = tratmenTakeMethod === "Flower" ? "פרח" : tratmenTakeMethod
            tratmenTakeMethod = tratmenTakeMethod === "Oil drops" ? "טיפות שמן" : tratmenTakeMethod
            tratmenTakeMethod = tratmenTakeMethod === "Precision Dosing Devices" ? "משאף למינון מדוד" : tratmenTakeMethod
            tratmenTakeMethod = tratmenTakeMethod === "Other" ? Other_treatment_intake_method : tratmenTakeMethod

            tratmenTakeMethod = tratmenTakeMethod === "Oil Vape" ? "אידוי שמן" : tratmenTakeMethod
            tratmenTakeMethod = tratmenTakeMethod === "Flower Smoking" ? "פרח עישון" : tratmenTakeMethod
            tratmenTakeMethod = tratmenTakeMethod === "Edible" ? "מאכל" : tratmenTakeMethod

            addFlowerInstruction = tratmenTakeMethod.includes('פרח')

            treatmentsArr.push('<div style="display: flex;align-items: center;justify-content: center;margin-top: 32px">' +
                '<div class="personal-Info2">' +
                '<div style="display: flex">' +
                '<div class="personal-InfoTitle">' + 'תכנית טיפול ' + (i + 1) + '</div>' +
                '</div>' +
                '<div class="personal-infoSubTitlesContainer">' +
                '<div style="width: 20%;margin-right: 35px;">' +
                '<div class="personal-infoSubTitles">קטגוריה</div>' +
                '<div class="personal-infoContent">' + tratmentCat + '</div>' +
                '</div>' +
                '<div style="width: 21%">' +
                '<div class="personal-infoSubTitles">מינון(גרם)</div>' +
                '<div class="personal-infoContent">' + tratmenDosage + '</div>' +
                '</div>' +
                '<div style="width: 20%">' +
                '<div class="personal-infoSubTitles">צורת מתן</div>' +
                '<div class="personal-infoContent">' + tratmenTakeMethod + '</div>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>')

        }


        treatmentInstructionMethod = addFlowerInstruction ? "<div>מומלץ לצרוך את הקנביס בעזרת מכשיר אידוי ולא בעישון עקב סכנה לנזקים ריאתיים משמעותיים מצריכה באמצעות עישון</div>" : treatmentInstructionMethod
        treatmentInstructionMethod = includeFlower ? treatmentInstructionMethod + "<div style='margin-top: 10px;'>יש ליטול שאיפה אחת בבוקר ושאיפה אחת בערב. להמתין שלשה ימים ואז במידת הצורך להעלות בשאיפה אחת בכל פעם. כך להעלות כל שלשה ימים עד שימצא המינון הנכון שבו יש יעילות אך אין תופעות לוואי משמעותיות. לעצור ב7 שאיפות בוקר ו7 שאיפות בערב</div>" : treatmentInstructionMethod
        treatmentInstructionMethod = includeOil ? treatmentInstructionMethod + "<div style='margin-top: 10px;'>יש ליטול טיפה אחת בבוקר וטיפה אחת בערב. להמתין שלשה ימים ואז במידת הצורך להעלות בשטיפה אחת בכל פעם. כך להעלות כל שלשה ימים עד שימצא המינון הנכון שבו יש יעילות אך אין תופעות לוואי משמעותיות. לעצור ב7 טיפות בבוקר אחר הצהרים ובערב.</div>" : treatmentInstructionMethod
        let notLicenseIdentify = 'מכתב זה הוא לא הרישיון לקנביס רפואי'
        let signature = 'בברכה, רופאי מערכת המרכז הארצי לרפואת כאב'
        let instructions = 'במידה ויש תופעות לוואי לחזור למינון הקודם.במידה ותופעות לוואי משמעותיות יש להפסיק את השימוש ולבקש יעוץ.במידה ותופעות לוואי חמורות יש להגיע למחלקת מיון בבית החולים הקרוב.'


        let diagnonses_ICD = this.params.medical_diagnoses_icd_name && this.params.medical_diagnoses_icd_name.label.toLowerCase() !== "other" ?
            this.params.medical_diagnoses_icd_name.label : this.params.other_diagnoses?this.params.other_diagnoses:""

        let currentDate = new Date()
        currentDate = currentDate.toISOString().split('T')
        let dateString = currentDate[0].split('-').reverse().join('/')

        let indication = this.params.patient_indication
        indication = indication === "Other" || indication === "אחר" ? this.params.other_patient_type_indication : indication
        if (indication === null || indication === undefined)
            indication = ""

        return (
            '<html dir="rtl" >' +
            ' <head></head>' +
            '<style>' +
            ' .pdf-Body {margin:0;zoom: 100%;max-width: 1000px;background:white;font-family: Assistant, sans-serif;}' +
            ' .pdf-Header {display: flex;justify-content:space-evenly;align-items:center;background:#f6f6f6;height:100px;width: 100%; }' +
            ' .pdf-SubHeader1 {min-width:51%;max-width:51%;display: flex;justify-content:start;font-family: Assistant, sans-serif;font-size: 1.375rem;width:max-content;align-items: center;color: #005f7f; }' +
            ' .pdf-SubHeader2 {background: white;height: 67px;min-width:35%;max-width:36%;font-family: Assistant, sans-serif;font-size: 0.875rem;}' +
            ' .pdf-Title {margin-left: 10px;font-weight: bold;width:50%;font-size: 1.2rem;}' +
            ' .pdf-Date { font-weight: 300;font-size: 1.2rem;width: 20%;}' +
            ' .pdfFile-details-block{page-break-inside:avoid;width:906px;min-height:103px;margin: 24px 47px 0 47px; padding: 0 0 25px;object-fit:contain;border-radius: 10px;  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);  background-color: #ffffff;}' +
            ' .pdfFile-details-title-block{ border-radius:10px 10px 0 0;padding: 8px 34px 7px 0;object-fit: contain;background-color: #f6f6f6;}' +
            ' .pdfFile-details-title-label{min-height: 18px;font-family: Assistant, sans-serif;font-size: 14px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: 1.57;letter-spacing: 0.35px;text-align: right;color: #005f7f;}' +
            ' .pdfFile-details-item-full{page-break-inside:avoid!important;padding: 27px 35px 4px 0;-webkit-box-flex: 1;-webkit-flex: 1;}' +
            ' .pdfFile-Instruction-Block{margin: 15px 0 10px 0;}' +
            ' .pdfFile-Instruction-items{display: flex;display: -webkit-box;-webkit-box-flex: 1;-webkit-flex: 1;}' +
            ' .pdfFile-Instruction-point{width: 6px;height: 6px;margin: 7px 0 16px 9px;object-fit: contain;background-color: #005f7f;border-radius: 50%;}' +
            ' .pdfFile-Instruction-subpoint{width: 5px;height: 5px;margin: 7px 10px 6px 9px;object-fit: contain;border: solid 0.5px #005f7f;;border-radius: 50%;}' +
            ' .pdfFile-Instruction-sentence{height: 18px;width: 90%;margin: 0 9px 11px 20px;font-family: Assistant, sans-serif;font-size: 14px;font-weight: 300;font-stretch: normal;font-style: normal;line-height: 1.40;letter-spacing: 0.35px;text-align: right;color: #1d1d1b;}' +
            ' .pdfFile-Instruction-sentence2{height: 40px;width: 90%;margin: 0 9px 11px 20px;font-family: Assistant, sans-serif;font-size: 14px;font-weight: 300;font-stretch: normal;font-style: normal;line-height: 1.40;letter-spacing: 0.35px;text-align: right;color: #1d1d1b;}' +
            ' .pdfFile-Instruction-sentence3{height: 50px;width: 90%;margin: 0 9px 11px 20px;font-family: Assistant, sans-serif;font-size: 14px;font-weight: 300;font-stretch: normal;font-style: normal;line-height: 1.40;letter-spacing: 0.35px;text-align: right;color: #1d1d1b;}' +
            ' .leumit-Title { margin-top:14px;margin-right:14px;margin-bottom: 3px;font-weight: bold;height: 28%;}' +
            ' .leumit-Address {display: flex;align-items: center;justify-content: space-around;font-weight: 300;opacity: 0.5;height: 30%;width:100%;}' +
            ' .personal-Info { border-radius: 10px;box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);width:90%;height: 382px;min-height: 382px;height: 480px;}' +
            ' .personal-Info2 { border-radius: 10px;box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);width:90%;height: 129px}' +
            ' .personal-InfoTitle {background:#f6f6f6;width:100%;border-top-left-radius: ' +
            '10px;border-top-right-radius: 10px;padding-right: 34px;color: #005f7f;font-weight: bold;display:flex;align-items: center;height: 33px;}' +
            '.personal-infoSubTitlesContainer {display: flex;align-items: start;}' +
            '.personal-infoSubTitlesContainer2 {display: flex;align-items: center;width: 100%}' +
            '.personal-infoSubTitles{font-size:0.875rem;font-family: Assistant, sans-serif;font-weight: 600;margin-top: 27px;}' +
            '.personal-infoContent {margin-top: 4px;font-family: Assistant, sans-serif;font-size: 1.125rem;font-weight: 300;opacity: 0.5;min-height: 15px;}' +
            '.personal-infoContentFooter {margin-top: 4px;font-family: Assistant, sans-serif;font-size: 0.875rem;font-weight: 300;opacity: 0.5;margin-right: 57px}' +
            '.clinic-infoContent {font-family: Assistant, sans-serif;font-size: 0.8rem;font-weight: 300;opacity: 0.5;width: 73%;}' +
            '.personal-border {border-top: 1px solid #dedbdb;margin-top: 26px;margin-right: 35px;margin-left: 35px;}' +
            '.instructionMethod {font-size: 0.875rem;font-family: Assistant, sans-serif;font-weight: 300;margin-top: 27px;margin-right: 35px;margin-left: 20px;}' +
            '.instructionMethod2 {font-size: 0.875rem;font-family: Assistant, sans-serif;font-weight: 300;margin-top: 10px;margin-right: 35px;margin-left: 20px;margin-bottom: 10px;}' +
            '</style>' +
            '<body class="pdf-Body">' +
            '<div class="pdf-Header" dir="rtl">' +
            '<div dir="rtl" class="pdf-SubHeader1">' +
            '<div class="pdf-Title">סיכום בקשה לרישיון קנאביס רפואי</div>' +
            '<div class="pdf-Date">' + dateString + '</div>' +
            '<div style="width: 30%;">' +
            `${logo}` + '</div></div>' +
            '<div class="pdf-SubHeader2" style="margin-right: 50px;" >' +
            '<div class="leumit-Title"> המרכז הארצי לרפואת כאב</div>' +
            '<div class="leumit-Address">' +
            `<div style="display: flex;align-items: center;width:40%;"><div style="width: 22%;">${phoneSVG}</div>` +
            '<div dir="rtl" class="clinic-infoContent">073-3807972</div></div>' +
            `<div style="display: flex;align-items: center;width:60%;"><div style="width: 13%;">${emailSVG}</div>  ` +
            '<div dir="rtl" class="clinic-infoContent">pain@sade.group</div></div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div style="width: 220px;position: relative;margin-left: auto;margin-right:auto;margin-top: 32px;font-size: 14px;font-family: Assistant, sans-serif;font-weight: 300">' + notLicenseIdentify + ' </div>' +
            '<div style="display: flex;align-items: center;justify-content: center;margin-top: 32px">' +
            '<div class="personal-Info">' +
            '<div style="display: flex">' +
            '<div class="personal-InfoTitle">פרטים אישיים</div>' +
            '</div>' +
            '<div class="personal-infoSubTitlesContainer">' +
            '<div style="width: 19%;margin-right: 35px;">' +
            '<div class="personal-infoSubTitles">שם מלא</div>' +
            '<div dir="rtl" class="personal-infoContent">' + firstName + ' ' + lastName + '</div>' +
            '</div>' +
            '<div style="width: 19%">' +
            '<div class="personal-infoSubTitles">תעודת זהות</div>' +
            '<div class="personal-infoContent">' + id + '</div>' +
            '</div>' +
            '<div style="width: 19%">' +
            '<div class="personal-infoSubTitles">גיל</div>' +
            '<div class="personal-infoContent">' + age + '</div>' +
            '</div>' +
            '<div style="width: 19%">' +
            '<div class="personal-infoSubTitles">טלפון</div>' +
            '<div class="personal-infoContent">' + phone + '</div>' +
            '</div>' +
            '</div>' +
            '<div class="personal-infoSubTitlesContainer">' +
            '<div style="width: fit-content;margin-right: 35px;">' +
            '<div class="personal-infoSubTitles">אימיל</div>' +
            '<div class="personal-infoContent">' + mail + '</div>' +
            '</div>' +
            '</div>' +
            '<div class="personal-border"></div>' +
            '<div class="personal-infoSubTitlesContainer" style="height: 120px;">' +
            '<div style="width: 34%;margin-right: 35px;">' +
            '<div class="personal-infoSubTitles">אינדיקציה</div>' +
            '<div class="personal-infoContent">' + indication + '</div>' +
            '</div>' +
            '<div style="width: 59%;margin-right: 35px;">' +
            '<div class="personal-infoSubTitles" style="word-break: break-all;width: 493px;">אבחנה</div>' +
            '<div class="personal-infoContent" style="height: 0px;">' + diagnonses_ICD + '</div>' +
            '</div>' +
            '</div>' +
            '<div class="personal-border"></div>' +
            '<div class="personal-infoSubTitlesContainer">' +
            '<div style="width: 34%;margin-right: 35px;">' +
            '<div class="personal-infoSubTitles">סוג בקשה</div>' +
            '<div class="personal-infoContent">' + programm + '</div>' +
            '</div>' +
            '<div style="width: 30%;margin-right: 35px;">' +
            '<div class="personal-infoSubTitles">סטטוס</div>' +
            '<div style="display: flex">' +
            ` ${checkSVG}` +
            '<div class="personal-infoContent">מאושר</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            treatmentsArr +
            '<div style="display: flex;align-items: center;justify-content: center;margin-top: 32px">' +
            '<div class="personal-Info2" style="height:fit-content;">' +
            '<div style="display: flex">' +
            '<div class="personal-InfoTitle"> אופן שימוש</div>' +
            '</div>' +
            '<div class="instructionMethod">' +
            treatmentInstructionMethod +
            '</div>' +
            '<div class="instructionMethod2">' +
            instructions +
            '</div>' +
            '</div></div>' +
            '<div style="margin-top: 32px;font-size: 14px;font-family: Assistant, sans-serif;font-weight: 300;margin-right: 57px;">' + signature + ' </div>' +
            '<div style="overflow-wrap: break-word;margin-top: 100px; min-height: 20px">' +
            '<div class="personal-infoContentFooter">מכיל מידע מוגן לפי חוק הגנת הפרטיות – המוסרו שלא כדין עובר עבירה</div>' +

            this.getInstructions() +

            '</div>' +
            '</body>' +
            '</html>'
        )
    }
}
